<script>
  import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
  <main>
    <div class="xu-gua2 show-book">
      <h5>【序卦 下】</h5>
      <p>
        有天地，然後有萬物；有萬物，然後有男女；有男女，然後有夫婦；有夫婦，然後有父子；有父子，然後有君臣；
        有君臣，然後有上下；有上下，然後禮義有所錯。
        夫婦之道，不可以不久也，故受之以恒。恒者，久也。
        物不可以久居其所，故受之以遯。遯者，退也。物不可以終遯，故受之以大壯。
        物不可以終壯，故受之以晉。晉者，進也。
        進必有所傷，故受之以明夷。夷者，傷也。傷於外者必反其家，故受之以家人。
        家道窮必乖，故受之以睽。睽者，乖也。乖必有難，故受之以蹇。蹇者，難也。
        物不可以終難，故受之以解，解者緩也。 緩必有所失，故受之以損。
        損而不已必益，故受之以益。 益而不已必決，故受之以夬。夬者，決也。
        決必有所遇，故受之以姤。姤者，遇也。
        物相遇而後聚，故受之以萃。萃者，聚也。聚而上者謂之升，故受之以升。
        升而不已必困，故受之以困。困乎上者必反下，故受之以井。
        井道不可不革，故受之以革。革物者莫若鼎，故受之以鼎。
        主器者莫若長子，故受之以震。震者，動也。
        物不可以終動，止之，故受之以艮。艮者，止也。
        物不可以終止，故受之以漸，漸者進也。進必有所歸，故受之以歸妹。
        得其所歸者必大，故受之以豐。豐者，大也。窮大者必失其居，故受之以旅。
        旅而无所容，故受之以巽。巽者，入也。入而後說之，故受之以兌。兌者，說也。
        說而後散之，故受之以渙。渙者，離也。物不可以終離，故受之以節。
        節而信之，故受之以中孚。有其信者必行之，故受之以小過。
        有過物者必濟，故受之以既濟。物不可窮也，故受之以未濟終焉。
      </p>
    </div>
  </main>
{:else}
  <main>
    <div class="xu-gua2 show-book">
      <h5>【序卦 下】</h5>
      <p>
        有天地，然后有万物；有万物，然后有男女；有男女，然后有夫妇；有夫妇，然后有父子；有父子，然后有君臣；
        有君臣，然后有上下；有上下，然后礼义有所错。
        夫妇之道，不可以不久也，故受之以恒。恒者，久也。
        物不可以久居其所，故受之以遯。遯者，退也。物不可以终遯，故受之以大壮。
        物不可以终壮，故受之以晋。晋者，进也。
        进必有所伤，故受之以明夷。夷者，伤也。伤于外者必反其家，故受之以家人。
        家道穷必乖，故受之以睽。睽者，乖也。乖必有难，故受之以蹇。蹇者，难也。
        物不可以终难，故受之以解，解者缓也。 缓必有所失，故受之以损。
        损而不已必益，故受之以益。 益而不已必决，故受之以夬。夬者，决也。
        决必有所遇，故受之以姤。姤者，遇也。
        物相遇而后聚，故受之以萃。萃者，聚也。聚而上者谓之升，故受之以升。
        升而不已必困，故受之以困。困乎上者必反下，故受之以井。
        井道不可不革，故受之以革。革物者莫若鼎，故受之以鼎。
        主器者莫若长子，故受之以震。震者，动也。
        物不可以终动，止之，故受之以艮。艮者，止也。
        物不可以终止，故受之以渐，渐者进也。进必有所归，故受之以归妹。
        得其所归者必大，故受之以丰。丰者，大也。穷大者必失其居，故受之以旅。
        旅而无所容，故受之以巽。巽者，入也。入而后说之，故受之以兑。兑者，说也。
        说而后散之，故受之以涣。涣者，离也。物不可以终离，故受之以节。
        节而信之，故受之以中孚。有其信者必行之，故受之以小过。
        有过物者必济，故受之以既济。物不可穷也，故受之以未济终焉。
      </p>
    </div>
  </main>
{/if}

<style>
  .show-book {
    /* height: 400px; */
    font-size: 20px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
  }
</style>
